<div [class]="envClass" class="main-container">

    <mat-toolbar class="custom-toolbar">
        <span>Calendar</span>
        <span class="spacer"></span>
        <button mat-icon-button (click)="save()" class="has-tooltip" data-tooltip="Save">
            <mat-icon>save</mat-icon>
        </button>
        <button mat-icon-button (click)="delete()" class="has-tooltip" data-tooltip="Delete">
            <mat-icon>delete</mat-icon>
        </button>
        <button mat-icon-button (click)="revoke()" class="has-tooltip" data-tooltip="Revoke and delete"
            *ngIf="accountType?.code==='APP_REGISTRATION'">
            <mat-icon>person_off</mat-icon>
        </button>
        <button mat-icon-button (click)="reconsent()" class="has-tooltip" data-tooltip="Reconsent"
            *ngIf="accountType?.code==='APP_REGISTRATION'">
            <mat-icon>edit_note</mat-icon>
        </button>
        <button mat-icon-button (click)="refreshCalendars()" class="has-tooltip" data-tooltip="Refresh calendars"
            *ngIf="accountType?.code==='APP_REGISTRATION'">
            <mat-icon>refresh</mat-icon>
        </button>
    </mat-toolbar>

    <div class="full-width">
        <mat-form-field appearance="outline" subscriptSizing="dynamic">
            <mat-label>Name</mat-label>
            <input matInput [(ngModel)]="calendarIntegration.description">
        </mat-form-field>

        <mat-form-field appearance="outline" subscriptSizing="dynamic">
            <mat-label>Calendar type</mat-label>
            <input matInput [(ngModel)]="calendarIntegration.accountTypeName" readonly>
        </mat-form-field>

        <mat-form-field appearance="outline" subscriptSizing="dynamic">
            <mat-label>Email Address</mat-label>
            <input matInput [formControl]="emailControl" placeholder="e.g. user@domain.com" type="email">

            <mat-error *ngIf="emailControl.invalid && (emailControl.dirty || emailControl.touched)">
                {{ getErrorMessage() }}
            </mat-error>
        </mat-form-field>

        <!----- App Registration -------------------------------------------------------------------------->
        <div *ngIf="accountType?.code=='APP_REGISTRATION'">

            <mat-form-field appearance="outline">
                <mat-label>Provider</mat-label>
                <input matInput [(ngModel)]="calendarIntegration.provider" readonly>
            </mat-form-field>

            <div class="table-container">
                <table mat-table [dataSource]="dataSource" class="full-width-table">
                    <ng-container matColumnDef="Title">
                        <th mat-header-cell *matHeaderCellDef> Title </th>
                        <td mat-cell *matCellDef="let element"> {{element.summary}} </td>
                    </ng-container>

                    <ng-container matColumnDef="Show in dashboard">
                        <th mat-header-cell *matHeaderCellDef> Show in dashboard </th>
                        <td mat-cell *matCellDef="let element"> {{element.showInDashboard ? '✓' : '✕'}} </td>
                    </ng-container>

                    <ng-container matColumnDef="Show in notes">
                        <th mat-header-cell *matHeaderCellDef> Show in notes </th>
                        <td mat-cell *matCellDef="let element"> {{element.showInNotes ? '✓' : '✕'}} </td>
                    </ng-container>

                    <ng-container matColumnDef="Calendar color">
                        <th mat-header-cell *matHeaderCellDef> Color </th>
                        <td mat-cell *matCellDef="let element">
                            <div class="color-circle" [style.background-color]="element.color"
                                [matTooltip]="element.calendarColor"> </div>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="openCalendarModal(row)"
                        class="clickable-row"></tr>
                </table>
            </div>

        </div>

        <!----- YOURNOTES -------------------------------------------------------------------------->
        <div *ngIf="accountType?.code=='YOURNOTES'" class="form-column-ical">
            <mat-form-field appearance="outline" subscriptSizing="dynamic">
                <mat-label>Calendar name</mat-label>
                <input matInput [(ngModel)]="calendar.summary">
            </mat-form-field>

            <div class="field-row-checkbox">
                <mat-checkbox color="primary" [(ngModel)]="calendar.showInDashboard">
                    Show in dashboard
                </mat-checkbox>
            </div>

            <div class="field-row-checkbox">
                <mat-checkbox color="primary" [(ngModel)]="calendar.showInNotes">
                    Show in notes
                </mat-checkbox>
            </div>

            <div class="field-row color-picker-inline">
                <app-color-picker [selectedColor]="calendar.color" (colorChange)="onColorSelect($event)">
                </app-color-picker>
                <label class="field-label-inline">Calendar Color</label>
            </div>

        </div>

        <!----- iCal -------------------------------------------------------------------------->
        <div *ngIf="accountType?.code=='ICAL'" class="form-column-ical">
            <mat-form-field appearance="outline" subscriptSizing="dynamic">
                <mat-label>Calendar name</mat-label>
                <input matInput [(ngModel)]="calendar.summary">
            </mat-form-field>

            <mat-form-field appearance="outline" subscriptSizing="dynamic">
                <mat-label>URL</mat-label>
                <input matInput [(ngModel)]="iCal.url">
            </mat-form-field>

            <div class="field-row-checkbox">
                <mat-checkbox color="primary" [(ngModel)]="calendar.showInDashboard">
                    Show in dashboard
                </mat-checkbox>
            </div>

            <div class="field-row-checkbox">
                <mat-checkbox color="primary" [(ngModel)]="calendar.showInNotes">
                    Show in notes
                </mat-checkbox>
            </div>

            <div class="field-row color-picker-inline">
                <app-color-picker [selectedColor]="calendar.color" (colorChange)="onColorSelect($event)">
                </app-color-picker>
                <label class="field-label-inline">Calendar Color</label>
            </div>

        </div>

        <!----- CalDav -------------------------------------------------------------------------->

        <div *ngIf="accountType?.code=='CALDAV'">
            <mat-tab-group style="margin-top: -5px">

                <mat-tab>
                    <ng-template mat-tab-label>
                        <mat-icon>calendar_month</mat-icon>
                        <mat-label style="margin-left: 15px">Linked calendars</mat-label>
                    </ng-template>

                    <div class="table-container">
                        <table mat-table [dataSource]="dataSource" class="full-width-table">
                            <ng-container matColumnDef="Title">
                                <th mat-header-cell *matHeaderCellDef> Title </th>
                                <td mat-cell *matCellDef="let element"> {{element.summary}} </td>
                            </ng-container>

                            <ng-container matColumnDef="Show in dashboard">
                                <th mat-header-cell *matHeaderCellDef> Show in dashboard </th>
                                <td mat-cell *matCellDef="let element">
                                    <mat-checkbox [(ngModel)]="element.showInDashboard" color="primary"></mat-checkbox>
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="Show in notes">
                                <th mat-header-cell *matHeaderCellDef> Show in notes </th>
                                <td mat-cell *matCellDef="let element">
                                    <mat-checkbox [(ngModel)]="element.showInNotes" color="primary"></mat-checkbox>
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="Calendar color">
                                <th mat-header-cell *matHeaderCellDef> Color </th>
                                <td mat-cell *matCellDef="let element">
                                    <app-color-picker [selectedColor]="element.color"
                                        (colorChange)="element.color = $event">
                                    </app-color-picker>
                                </td>
                            </ng-container>

                            <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                        </table>
                    </div>

                </mat-tab>

                <mat-tab>

                    <ng-template mat-tab-label>
                        <mat-icon>manage_accounts</mat-icon>
                        <mat-label style="margin-left: 15px">CalDAV Account</mat-label>
                    </ng-template>

                    <mat-form-field appearance="outline" style="padding-top: 20px;" subscriptSizing="dynamic">
                        <mat-label>Caldav URL</mat-label>
                        <input matInput [(ngModel)]="calDav.url">
                    </mat-form-field>
                    <mat-form-field appearance="outline" subscriptSizing="dynamic">
                        <mat-label>Caldav username</mat-label>
                        <input matInput [(ngModel)]="calDav.username">
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                        <mat-label>Caldav password</mat-label>
                        <input matInput [type]="hide ? 'password' : 'text'" placeholder="password"
                            [(ngModel)]="calDav.password" name="password" required #pw1="ngModel">
                        <mat-icon matSuffix (click)="hide = !hide" class="pointer-icon">
                            {{hide ? 'visibility_off' : 'visibility'}}
                        </mat-icon>
                        <mat-error *ngIf="pw1.invalid && (pw1.dirty || pw1.touched)">
                            Password is required.
                        </mat-error>
                    </mat-form-field>

                </mat-tab>
            </mat-tab-group>


        </div>
        <div *ngIf="error" class="alert-error" role="alert">
            {{ errorMessage }}
        </div>

    </div>
</div>